<template>
  <Steps :current="this.current">
    <Step class="setp-label" @click.native="gotoStep('confProjCtrAcct')" :title="$t('module.proj.project.step.confProjCtrAcct')" ></Step>
    <Step class="setp-label" @click.native="gotoStep('confProjSettleEntity')" :title="$t('module.proj.project.step.confProjSettleEntity')" ></Step>
    <Step class="setp-label" @click.native="gotoStep('confProjIncomeEntity')" :title="$t('module.proj.project.step.confProjIncomeEntity')" ></Step>
    <Step class="setp-label" @click.native="gotoStep('confProjAcctPayEntity')" :title="$t('module.proj.project.step.confProjAcctPayEntity')" ></Step>
    <Step class="setp-label" @click.native="gotoStep('confProjAcctReceiveEntity')" :title="$t('module.proj.project.step.confProjAcctReceiveEntity')" ></Step>
    <Step class="setp-label" @click.native="gotoStep('confProjAcctCurEntity')" :title="$t('module.proj.project.step.confProjAcctCurEntity')" ></Step>
  </Steps>
</template>

<script>
export default {
  props: {
    stepName: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    stepArray() {
      return this.$store.state.confProjectStepManage.stepArray
    },
    current: {
      get() {
        // debugger
        return this.$store.state.confProjectStepManage.current
      },
      set(value) {
        this.$store.commit('confProjectStepManage/updateCurrent', value)
      }
    }
  },
  methods: {
    async gotoStep(stepName) {
      console.log('current', this.current, 'stepName', stepName, this.stepArray.indexOf(stepName))
      if (this.current !== this.stepArray.indexOf(stepName)) {
        await this.$router.push({path: ('/proj/project/' + stepName), query: {projId: this.$route.query.projId, compId: this.$route.query.compId, menuKey: this.$route.query.menuKey}})
      }
    }
  },
  async mounted() {
    // debugger
    console.log('stepName', this.stepName, this.stepArray.indexOf(this.stepName))
    this.current = this.stepArray.indexOf(this.stepName)
    // this.gotoStep(this.stepName)
  }
}
</script>

<style lang="less" >
@import '../../theme/index.less';
.setp-label {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/proj/ConfProjectStep.vue